import { APP_USER_GROUPING_MASTER_ROUTE, APP_USER_GROUPING_ROUTE } from "config/route-consts";
import { Switch } from "react-router-dom";

import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import AppUserGroupingMaster from "./AppUserGroupingMaster/AppUserGroupingMaster";
import { authorizationService } from "services/common-services/authorization-service";
import AppUserGroupingHistoryView from "./AppUserGroupingHistory/AppUserGroupingHistoryView";

function AppUserGroupingView() {
  const { auth } = authorizationService.useAuthorizedRoute();

  return (
    <Switch>
      <ProtectedRoute
        path={APP_USER_GROUPING_MASTER_ROUTE}
        key={APP_USER_GROUPING_MASTER_ROUTE}
        component={AppUserGroupingMaster}
        auth={auth(APP_USER_GROUPING_MASTER_ROUTE)}
      />
      <ProtectedRoute
        path={APP_USER_GROUPING_ROUTE}
        key={APP_USER_GROUPING_ROUTE}
        component={AppUserGroupingHistoryView}
        auth={auth(APP_USER_GROUPING_ROUTE)}
      />
    </Switch>
  );
}

export { AppUserGroupingMaster };
export default AppUserGroupingView;
